import React, { useEffect } from 'react';
import i18n from '@/settings/i18n';
import { FormatError } from '@/services/api';
import { LoginMenu } from '../Presentation/LoginMenu';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import { sentryReportError } from '@/utils/sentryReportError';

type Props = {
  error: FormatError<any>;
  isLoggedIn: boolean;
};

export const LoginMenuContainer: React.FC<Props> = ({ error, isLoggedIn }) => {
  const { flashError } = useFlashMessenger();
  useEffect(() => {
    if (error) {
      sentryReportError(error);
      flashError(i18n.t('ui.error.unexpected'));
    }
  }, [error, flashError]);

  if (!isLoggedIn) {
    return null;
  }

  return <LoginMenu />;
};
